/**
 * PositionSelect - Position selection component for sell orders
 */
import React from 'react';
import { PositionInfo } from '../../types/portfolio';

interface PositionSelectProps {
  positions: PositionInfo[];
  positionsLoading: boolean;
  symbol: string;
  onSelectPosition: (position: PositionInfo) => void;
}

const PositionSelect: React.FC<PositionSelectProps> = ({
  positions,
  positionsLoading,
  symbol,
  onSelectPosition,
}) => {
  if (positionsLoading) {
    return <div className="positions-loading">포지션 조회 중...</div>;
  }

  if (positions.length === 0) {
    return <div className="positions-empty">보유 포지션이 없습니다</div>;
  }

  return (
    <div className="positions-list-select">
      {positions.map((pos) => {
        const isProfit = pos.unrealized_pl_percent >= 0;
        return (
          <button
            key={pos.symbol}
            type="button"
            className={`position-item ${symbol === pos.symbol ? 'selected' : ''}`}
            onClick={() => onSelectPosition(pos)}
          >
            <div className="position-header">
              <span className="position-symbol">{pos.symbol}</span>
              <span className="position-badge stock">주식</span>
            </div>
            <div className="position-details">
              <span className="position-qty">보유: {formatQuantity(pos.qty)}</span>
              <span className={`position-pl ${isProfit ? 'profit' : 'loss'}`}>
                {isProfit ? '+' : ''}
                {pos.unrealized_pl_percent.toFixed(2)}%
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

function formatQuantity(value: number): string {
  return value.toLocaleString('ko-KR', { maximumFractionDigits: 6 });
}

export default PositionSelect;
